import React from 'react';

const Footer = ({ isNavOpen }) => {
  // Update this BACK_URL to match your backend address
  const BACK_URL = process.env.REACT_APP_BACKEND_URL

  const logoBlack = `${BACK_URL}/media/home/dnzify-logo-black.png`;
  const logoBlackHorizontal = `${BACK_URL}/media/home/dnzify-logo-black-horizontal.png`;

  return (
    <footer className={`footer ${isNavOpen ? "footer-squeezed" : ""}`}>
      <a href="https://www.dnzify.com" target="_blank" rel="noopener noreferrer">
        <img
          src={logoBlackHorizontal}
          alt="Dnzify Logo"
          className="footer-logo"
          style={{ height: "75px", objectFit: "contain" }}
        />
      </a>
    </footer>
  );
};

export default Footer;
